// export const API_BASE = 'http://localhost:5002';
export const API_BASE = 'https://ruouvangsq.com';
